import { PreviewStep } from 'experiences/explore/loans/components/PreviewOffersWidget'
import { ArticleSummary } from 'services/ContentfulService/models/articles'
import { Hero } from 'shared/layout/Hero'
import { Heading, Paragraph, Typography } from 'ui/typography'
import { Container } from 'shared/layout/Container'
import { Box } from 'ui/primitives'
import { ArticleSection } from 'shared/learn/ArticleSection'

interface Props {
	articles: Array<ArticleSummary>
}

export const LoansPreviewPage = ({ articles }: Props) => (
	<>
		<Hero>
			<Heading.H1>
				Find a <Typography color="secondary.main">personal loan.</Typography>
			</Heading.H1>
			<Paragraph>
				Filter and choose from our top offers below to see if you qualify. If not, we will match you with a more
				appropriate offer.
			</Paragraph>
		</Hero>

		<Container>
			<PreviewStep />
			<Box paddingY="xxl">
				<ArticleSection articles={articles} />
			</Box>
		</Container>
	</>
)
